import { Badge } from '@ui/components/Badge';
import { ErrorIcon } from '@ui/icons/ErrorIcon';

import { TournamentStatus } from '@features/shared/api/typings';

import styles from '../TournamentSubHeader.module.css';

type Props = {
  tournament?: {
    status: TournamentStatus;
    rcfRankCalculated: boolean;
  };
  isReportAvailable: boolean;
  error?: string;
  onClick: () => void;
};

export function TournamentRcfBadge({ tournament, isReportAvailable, error, onClick }: Props) {
  if (!tournament?.rcfRankCalculated || tournament?.status !== 'Finished') return null;

  return (
    <Badge
      className={styles.rcfBadge}
      size="m"
      flat
      onClick={isReportAvailable ? onClick : undefined}
      title={error}
    >
      Отчет ФШР
      {!isReportAvailable && error && <ErrorIcon />}
    </Badge>
  );
}
